import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { addOrganizationCreateRequest } from '@src/api'
import {
  AddOrganizationCreateRequest200Response,
  DefaultApiAddOrganizationCreateRequestRequest,
} from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { AddOrganizationCreateResponseError } from './type'

export const useAddOrganizationCreateRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    AxiosResponse<AddOrganizationCreateRequest200Response>,
    AxiosResponse<AddOrganizationCreateResponseError>,
    DefaultApiAddOrganizationCreateRequestRequest
  >({
    mutationFn: (params: DefaultApiAddOrganizationCreateRequestRequest) =>
      addOrganizationCreateRequest(axiosInstance, params),
  })
}
